import React from 'react';
import * as mobxReact from 'mobx-react';
import Spinner from '../../../../global/spinner/spinner';
import { FormField } from '../../../../global/form/form-field/form-field';
import UploadButton, { FILE_TYPE } from '../upload-button';
import UploadAudioS3VM from './upload-audio-to-s3.viewmodel';
import { AudioWaveFile } from '../../../../global/audio-wave/audio-wave-file';

interface IUploadAudioS3PresentationProps {
    vm: UploadAudioS3VM;
    fieldName?: string | React.ReactNode;
    infoIconText?: string | null;
    disabled?: boolean;
    onDeleteFile: () => void;
}

const UploadAudioS3Presentation = mobxReact.observer(({
    vm,
    fieldName,
    infoIconText = null,
    disabled = false,
    onDeleteFile,
}: IUploadAudioS3PresentationProps) => {
    const onFilePicked = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files[0];
        e.target.value = null;
        vm.setAudio(file);
    };

    return (
        <FormField className='upload-audio-field' label={fieldName} infoIconText={infoIconText}>
            {vm.isAudioUploading
                ? <Spinner />
                : vm.hasAudio()
                    ? <AudioWaveFile
                        audioSrc={vm.file ? '' : vm.getAudioSource()}
                        audioBlob={vm.file}
                        audioName={vm.getAudioName()}
                        onChange={onFilePicked}
                        deleteAudio={onDeleteFile}
                        disabled={disabled}
                    />
                    : <UploadButton
                        uploadedFileType={FILE_TYPE.AUDIO}
                        onChange={file => vm.setAudio(file as File)}
                        disabled={disabled}
                    />
            }
            {!!vm.audioError && <span className='oe-form-field__error'>{vm.audioError}</span>}
        </FormField>
    );
});

export { UploadAudioS3Presentation };
